import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { TaskResponse } from '../../../types/Task';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

type TaskFilterKey =
  | 'event_type'
  | 'task_type'
  | 'task_status'
  | 'event_location'
  | 'account'
  | 'events'
  | 'employee'
  | 'due_date_range';

export type TaskFilterParam = {
  [K in TaskFilterKey]?: string[];
};

export type TaskSortParam = {
  [K in TaskAvailableColumns]?: -1 | 1;
};

export type TaskAvailableColumns =
  | 'name'
  | 'task_template_name'
  | 'event_display_name'
  | 'account_code'
  | 'account_name'
  | 'start_date'
  | 'due_date'
  | 'status'
  | 'due_status'
  | 'employee_display_name'
  | 'employee_email'
  | 'tags';

export interface UseGetAllTasksParams {
  page?: number;
  per_page?: number;
  search?: string;
  filters?: TaskFilterParam;
  sort?: TaskSortParam;
  list_columns?: TaskAvailableColumns[];
}

type UseGetAllTasksProps = {
  params?: UseGetAllTasksParams;
  enabled?: boolean;
};

const fetchAllTasks = async ({ params }: UseGetAllTasksProps) => {
  const response = await CustomAxios.get<TaskResponse>(`tasks`, { params });
  const { data } = response;
  return data;
};

export function useGetAllTasks({ params, enabled = true }: UseGetAllTasksProps) {
  const queryKey = [queryKeys.allTasks, params];
  const query = useQuery({
    enabled,
    queryKey,
    queryFn: () => fetchAllTasks({ params }),
    placeholderData: keepPreviousData,
  });
  return query;
}
